import { ReactNode } from 'react';
import { ThemeProvider, ThemeProviderProps } from '@mui/material/styles';
import { watchdutyTheme } from './watchdutyTheme';

type WatchDutyThemeProviderProps = Omit<ThemeProviderProps, 'theme'> & {
  children: ReactNode;
};

export const WatchDutyThemeProvider = (
  props: WatchDutyThemeProviderProps,
): JSX.Element => {
  const { children, ...providerProps } = props;

  // `forceThemeRerender` restores v6 behavior where switching color scheme
  // triggers a theme re-render so `theme.palette.X` reads return the active
  // scheme's value. Without this, v7 freezes `theme.palette.X` to the initial
  // scheme and dark mode silently fails for any consumer not using
  // `theme.vars.palette.X` or `theme.applyStyles('dark', …)`.
  return (
    <ThemeProvider {...providerProps} theme={watchdutyTheme} forceThemeRerender>
      {children}
    </ThemeProvider>
  );
};
